module.exports = __webpack_public_path__ + "static/KON-desktop-f607f14fed1129db196b32bd6ba5e37e.png";